import moment from 'moment-timezone';
import i18next from 'i18next';

import {capitalizeFirstLetter} from 'web-app/util/string';
import {hasValue} from 'web-app/util/typescript';

import {BucketType} from './constants';

export const getHeaderForBucket = (bucket: string) => {
    const date = moment(bucket);

    // As of right now, the bucket can either be a date, or a case from BucketType
    if (date.isValid()) {
        return date.format('MMM YY');
    } else {
        switch (bucket.toLowerCase()) {
            // If we can recognize the BucketType we map it to a translation, otherwise we pass it through
            case BucketType.totals:
                return i18next.t('plans.revenue.totals');
            default:
                return capitalizeFirstLetter(bucket);
        }
    }
};

export const isFetchRequest = (response: any): boolean => {
    // if the response contains billPayers that means the request originated from an institution
    // if the response contains institutions that means the request originated from an organization
    return hasValue(response.billPayers) || hasValue(response.institutions);
};
